"use strict";

exports.__esModule = true;
exports.DebouncedRender = void 0;
var _react = require("react");
var _Utils = require("../../../Utils");
var _excluded = ["delay", "children"];
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function createState(props) {
  var _delay = props.delay,
    _children = props.children,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  return extra;
}

/**
 * Debounces via a render prop.
 */
var DebouncedRender = exports.DebouncedRender = /*#__PURE__*/function (_Component) {
  function DebouncedRender() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = createState(_this.props);
    _this.shouldRender = false;
    _this.updateState = (0, _Utils.debounce)(function (props) {
      _this.shouldRender = true;
      _this.setState(createState(props));
    }, {
      delay: _this.props.delay
    });
    return _this;
  }
  _inheritsLoose(DebouncedRender, _Component);
  var _proto = DebouncedRender.prototype;
  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(props) {
    this.shouldRender = false;
    this.updateState(props);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.updateState.cancel();
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate() {
    return this.shouldRender;
  };
  _proto.render = function render() {
    var children = this.props.children;
    return children(this.state);
  };
  return DebouncedRender;
}(_react.Component);
DebouncedRender.defaultProps = {
  delay: 200
};